<div class="page-container">
  <div class="page" [ngClass]="{active: activePage().get(PageId.INTRO)}">
    <cov-inquiry-intro
      [orderNumber]="inquiryService.order()?.orderId ?? ''"
      [itemNumber]="inquiryService.order()?.orderItemPosition | removeLeadingZeros"
      (changePage)="changePage($event)"
    />
  </div>
  <div class="page" [ngClass]="{active: activePage().get(PageId.INQUIRY_FORM)}">
    <cov-inquiry-contact-panel
      [active]="activePage().get(PageId.INQUIRY_FORM)"
      [order]="activeOrder()"
      [contactEmail]="data.contactEmail"
      [soldTos]="soldToService.allAddresses()"
      (cancelInquiry)="currentPage.set($event)"
      (inquiryCreated)="closeSidePanel()"
    />
  </div>
  <div class="page" [ngClass]="{active: activePage().get(PageId.ORDER_SELECT)}">
    <cov-inquiry-order-select-panel
      [active]="activePage().get(PageId.ORDER_SELECT)"
      (cancelOrderSelect)="currentPage.set($event)"
      (selectedOrder)="onSelectedOrder($event)"
    />
  </div>
</div>
